import { createAction } from '@reduxjs/toolkit'

/**
 * Raised by the API layer when the backend rejects the current token (401).
 * Lives outside the auth slice so `root.api` can dispatch it without importing
 * the slice (which imports the api back).
 */
const sessionExpired = createAction('auth/sessionExpired')

/** Raised on 403: the token is valid, this account just cannot do that. */
const accessForbidden = createAction('auth/accessForbidden')

/**
 * Requests the RBAC permission set. Dispatched from the boot chain, from the
 * flag/token listener when RBAC turns on late, and from the retry affordance
 * on a gated route.
 */
const fetchMyRoles = createAction('auth/fetchMyRoles')

export { accessForbidden, fetchMyRoles, sessionExpired }
